import { Component, ContentChild, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { PayeeDropdownComponent } from '../payee-form-fields/payee-dropdown/payee-dropdown.component';
import { PayeeLanguageSelectorComponent } from '../payee-language-selector/payee-language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'payee-header',
  templateUrl: './payee-header.component.html',
  styleUrls: ['./payee-header.component.scss'],
  imports: [
    NgTemplateOutlet,
    PayeeDropdownComponent,
    PayeeLanguageSelectorComponent,
    TranslateModule,
  ],
})
export class PayeeHeaderComponent {
  @ContentChild('payeeHeaderLogoTemplate')
  headerLogoTemplateRef?: TemplateRef<any>;
  @ContentChild('payeeHeaderButtonTemplate')
  headerButtonTemplateRef?: TemplateRef<any>;
}
